import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subscription, timer } from "rxjs";
import { environment } from "../../../environments/environment";
import { AzureToken } from "../interfaces/token.interface";

@Injectable({
    providedIn: "root"
})
export class GetTokenService {
    private tokenSubject = new BehaviorSubject<AzureToken | null>(null);
    token$ = this.tokenSubject.asObservable();

    private refreshSub?: Subscription;
    private sessionStart = Date.now();

    constructor(private http: HttpClient) {
        this.getToken();
    }

    getToken() {
        const url = `${environment.tokenServer}/gettoken?${Math.floor(Math.random() * 99999999)}`;
        this.http.get<AzureToken>(url).subscribe((token) => {
            this.tokenSubject.next(token);
            this.scheduleTokenRefresh(token);
        });
    }

    private scheduleTokenRefresh(token: AzureToken) {
        // Renews 1 minute before token expires
        const expiresIn = (token.expires_in ?? 3599) * 1000;
        const renewBefore = 60 * 1000;
        const sessionElapsed = Date.now() - this.sessionStart;
        const sessionLimit = 8 * 60 * 60 * 1000;
        const refreshTime = expiresIn - renewBefore;
        // const refreshTime = 60000; // For testing purposes, refreshes every minute

        // If a session lasts longer than 8 hours the token will not be renewed
        if (sessionElapsed + expiresIn > sessionLimit) {
            return;
        }

        if (this.refreshSub) {
            this.refreshSub.unsubscribe();
        }

        this.refreshSub = timer(refreshTime).subscribe(() => this.getToken());
    }
}
